"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferrerContextProvider = exports.ReferrerContext = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
exports.ReferrerContext = react_1.default.createContext({
    referrer: undefined,
    refTag: 'NONE',
});
var ReferrerContextProvider = function (props) {
    var _a;
    var history = (0, react_router_dom_1.useHistory)();
    var searchParams = new URLSearchParams(history.location.search);
    var _b = (0, react_1.useState)({ referrer: document.referrer, refTag: (_a = searchParams.get('ref_')) !== null && _a !== void 0 ? _a : 'NONE' }), context = _b[0], setContext = _b[1];
    var _c = (0, react_1.useState)(history.location.pathname), lastLocation = _c[0], setLastLocation = _c[1];
    (0, react_1.useEffect)(function () {
        return history.listen(function (location) {
            if (lastLocation) {
                setContext(__assign(__assign({}, context), { referrer: lastLocation }));
            }
            setLastLocation(location.pathname);
        });
    }, [history, lastLocation, setLastLocation, setContext]);
    return react_1.default.createElement(exports.ReferrerContext.Provider, { value: context }, props.children);
};
exports.ReferrerContextProvider = ReferrerContextProvider;
